export type {};

declare global {
  interface Set<T> {
    difference(this: Set<T>, target: Set<T>): Set<T>;
    intersect(this: Set<T>, target: Iterable<T>): T[];
    toArray(this: Set<T>): T[];
    toFrozen(this: Set<T>): Readonly<Set<T>>;
  }

  interface SetConstructor {
    isSet<T>(arg: any): arg is Set<T>;
  }
}

if (!Set.isSet) {
  Set.isSet = function <T>(arg: any): arg is Set<T> {
    return arg instanceof Set;
  };
}

const { prototype } = Set;

if (!prototype.difference) {
  Object.defineProperty(prototype, 'difference', {
    writable: false,
    enumerable: false,
    value: function <T>(this: Set<T>, target: Set<T>): Set<T> {
      const result = new Set(this);
      target.forEach(result.delete, result);

      return result;
    }
  });
}

if (!prototype.intersect) {
  Object.defineProperty(prototype, 'intersect', {
    writable: false,
    enumerable: false,
    value: function <T>(this: Set<T>, target: Iterable<T>): T[] {
      if (!Set.isSet(target)) {
        return this.intersect(new Set(target));
      }

      return this.toArray().filter((x) => target.has(x));
    }
  });
}

if (!prototype.toArray) {
  Object.defineProperty(prototype, 'toArray', {
    writable: false,
    enumerable: false,
    value: function <T>(this: Set<T>): T[] {
      return [...this];
    }
  });
}

if (!prototype.toFrozen) {
  Object.defineProperty(prototype, 'toFrozen', {
    writable: false,
    enumerable: false,
    value: function <T>(this: Set<T>): Readonly<Set<T>> {
      return Object.freeze(this);
    }
  });
}
